(function () {
  'use strict';

  /* ----- Header scroll state — threshold 16px (matches the design) -------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 16);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ----- Mobile menu toggle + hamburger-to-X ----------------------------- */
  var menuBtn = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var closeMenu = function () {
    if (!mobileMenu || !mobileMenu.classList.contains('is-open')) return;
    mobileMenu.classList.remove('is-open');
    if (menuBtn) {
      menuBtn.classList.remove('is-open');
      menuBtn.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
  };
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('is-open');
      menuBtn.classList.toggle('is-open', open);
      menuBtn.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileMenu.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('[data-menu-close]')) closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
    var mql = window.matchMedia('(min-width: 861px)');
    (mql.addEventListener || mql.addListener).call(mql, 'change', function (e) {
      if (e.matches) closeMenu();
    });
  }

  /* ----- Video modal ------------------------------------------------------ */
  var modal = document.querySelector('[data-video-modal]');
  if (modal) {
    var frame = modal.querySelector('[data-video-frame]');
    var embed = modal.getAttribute('data-video-embed') || '';
    var openModal = function () {
      if (embed && frame && !frame.dataset.loaded) {
        frame.innerHTML =
          '<iframe src="' + embed + '" title="Founder message" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
        frame.dataset.loaded = '1';
      }
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };
    var closeModal = function () {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    document.querySelectorAll('[data-video-open]').forEach(function (btn) {
      btn.addEventListener('click', openModal);
    });
    modal.querySelectorAll('[data-video-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  /* ----- Work page: problem + service filters ----------------------------- */
  var problemBtns = document.querySelectorAll('[data-problem-btn]');
  var serviceBtns = document.querySelectorAll('[data-service-btn]');
  if (problemBtns.length || serviceBtns.length) {
    var caseTiles = Array.prototype.slice.call(document.querySelectorAll('[data-problem]'));
    var emptyNote = document.querySelector('[data-work-empty]');
    var activeProblem = 'all';
    var activeService = 'all';
    var tileTags = function (t) {
      return (t.getAttribute('data-tags') || '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
    };
    var matches = function (t, problem, service) {
      var pOk = problem === 'all' || t.getAttribute('data-problem') === problem;
      var sOk = service === 'all' || tileTags(t).indexOf(service) !== -1;
      return pOk && sOk;
    };
    var applyFilters = function () {
      var visible = 0;
      caseTiles.forEach(function (t) {
        var show = matches(t, activeProblem, activeService);
        t.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });
      problemBtns.forEach(function (b) {
        var key = b.getAttribute('data-problem-btn');
        var n = caseTiles.filter(function (t) { return matches(t, key, activeService); }).length;
        var meta = b.querySelector('.problem-card__meta');
        if (meta) meta.textContent = n + (n === 1 ? ' case' : ' cases');
        b.classList.toggle('is-active', key === activeProblem);
        b.setAttribute('aria-pressed', String(key === activeProblem));
      });
      serviceBtns.forEach(function (b) {
        var key = b.getAttribute('data-service-btn');
        b.classList.toggle('is-selected', key === activeService);
        b.setAttribute('aria-pressed', String(key === activeService));
      });
      if (emptyNote) emptyNote.hidden = visible > 0;
    };
    problemBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        activeProblem = b.getAttribute('data-problem-btn');
        applyFilters();
      });
    });
    serviceBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        activeService = b.getAttribute('data-service-btn');
        applyFilters();
      });
    });
  }

  /* ----- Sparklines — mirrors the prototype's SVG geometry ---------------- */
  document.querySelectorAll('[data-sparkline]').forEach(function (el) {
    var vals = el.getAttribute('data-sparkline').split(',').map(parseFloat).filter(isFinite);
    if (vals.length < 2) return;
    var W = 280, H = 84, pad = 6;
    var max = parseFloat(el.getAttribute('data-max'));
    if (!isFinite(max)) max = Math.max.apply(null, vals) * 1.15;
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('aria-hidden', 'true');
    var pts = vals.map(function (v, i) {
      var x = pad + i * ((W - pad * 2) / (vals.length - 1));
      var y = H - pad - (v / max) * (H - pad * 2);
      return [x, y];
    });
    var baseline = parseFloat(el.getAttribute('data-baseline'));
    if (isFinite(baseline)) {
      var ly = H - pad - (baseline / max) * (H - pad * 2);
      var line = document.createElementNS(NS, 'line');
      line.setAttribute('x1', pad); line.setAttribute('x2', W - pad);
      line.setAttribute('y1', ly); line.setAttribute('y2', ly);
      line.setAttribute('stroke', '#c9b8c4'); line.setAttribute('stroke-width', '1');
      line.setAttribute('stroke-dasharray', '3 4');
      svg.appendChild(line);
      var blabel = el.getAttribute('data-baseline-label');
      if (blabel) {
        var btext = document.createElementNS(NS, 'text');
        btext.setAttribute('x', W - pad); btext.setAttribute('y', ly - 6);
        btext.setAttribute('text-anchor', 'end'); btext.setAttribute('font-size', '10');
        btext.setAttribute('fill', '#8a8090'); btext.setAttribute('font-family', "'JetBrains Mono',monospace");
        btext.textContent = blabel;
        svg.appendChild(btext);
      }
    }
    var poly = document.createElementNS(NS, 'polyline');
    poly.setAttribute('points', pts.map(function (p) { return p.join(','); }).join(' '));
    poly.setAttribute('fill', 'none'); poly.setAttribute('stroke', '#5c1f56');
    poly.setAttribute('stroke-width', '2');
    poly.setAttribute('stroke-linejoin', 'round'); poly.setAttribute('stroke-linecap', 'round');
    svg.appendChild(poly);
    var pi = parseInt(el.getAttribute('data-peak-index'), 10);
    if (!isNaN(pi) && pts[pi]) {
      var dot = document.createElementNS(NS, 'circle');
      dot.setAttribute('cx', pts[pi][0]); dot.setAttribute('cy', pts[pi][1]);
      dot.setAttribute('r', '3.5'); dot.setAttribute('fill', '#e85d6e');
      svg.appendChild(dot);
      var plabel = el.getAttribute('data-peak-label');
      if (plabel) {
        var ptext = document.createElementNS(NS, 'text');
        ptext.setAttribute('x', pts[pi][0] + 8); ptext.setAttribute('y', pts[pi][1] + 4);
        ptext.setAttribute('font-size', '10'); ptext.setAttribute('fill', '#e85d6e');
        ptext.setAttribute('font-family', "'JetBrains Mono',monospace");
        ptext.textContent = plabel;
        svg.appendChild(ptext);
      }
    }
    el.appendChild(svg);
  });

  /* ----- Demo form: weekday chips (next 5 weekdays) ----------------------- */
  document.querySelectorAll('[data-demo-days]').forEach(function (row) {
    var labels = [];
    var d = new Date();
    while (labels.length < 5) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) {
        labels.push(d.toLocaleDateString('en-GB', { weekday: 'short' }) + ' ' + d.getDate() + ' ' + d.toLocaleDateString('en-GB', { month: 'short' }));
      }
    }
    labels.forEach(function (label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'chip-btn';
      b.setAttribute('data-value', label);
      b.setAttribute('aria-pressed', 'false');
      b.textContent = label;
      row.appendChild(b);
    });
  });

  /* ----- Chip groups: single-select pills feeding hidden inputs ----------- */
  document.querySelectorAll('[data-pill-group]').forEach(function (group) {
    var hidden = group.querySelector('input[type="hidden"]');
    var allowToggle = group.hasAttribute('data-toggle');
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-value]');
      if (!btn) return;
      var wasSelected = btn.classList.contains('is-selected');
      group.querySelectorAll('button[data-value]').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      if (!(allowToggle && wasSelected)) {
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
      }
      if (hidden) hidden.value = btn.classList.contains('is-selected') ? btn.getAttribute('data-value') : '';
      /* Compose the combined slot value (day · time TZ) */
      var form = group.closest('form');
      var slotInput = form && form.querySelector('[data-slot-input]');
      if (slotInput) {
        var day = form.querySelector('[data-pill-group="day"] .is-selected');
        var time = form.querySelector('[data-pill-group="time"] .is-selected');
        var tz = slotInput.getAttribute('data-tz') || '';
        var parts = [];
        if (day) parts.push(day.getAttribute('data-value'));
        if (time) parts.push(time.getAttribute('data-value') + (tz ? ' ' + tz : ''));
        slotInput.value = parts.join(' · ');
      }
    });
  });

  /* ----- Count-up numbers (data-countup / data-fmt / data-delay) --------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmtNum = function (v, f) {
    if (f === 'usd0') return '$' + Math.round(v).toLocaleString('en-US');
    if (f === 'usd2') return '$' + v.toFixed(2);
    if (f === 'pct2') return v.toFixed(2) + '%';
    return Math.round(v).toLocaleString('en-US');
  };
  var countEls = document.querySelectorAll('[data-countup]');
  if (countEls.length && !reduceMotion && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cio.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-countup'));
        if (!isFinite(target)) return;
        var f = el.getAttribute('data-fmt') || 'int';
        var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
        setTimeout(function () {
          var t0 = performance.now();
          var tick = function (now) {
            var p = Math.min(1, (now - t0) / 1400);
            var e = 1 - Math.pow(1 - p, 3);
            el.textContent = fmtNum(target * e, f);
            if (p < 1) requestAnimationFrame(tick); else el.textContent = fmtNum(target, f);
          };
          requestAnimationFrame(tick);
        }, delay);
      });
    }, { threshold: 0.5 });
    countEls.forEach(function (el) { cio.observe(el); });
  }

  /* ----- Case chart: monthly spend bars + ROAS line ----------------------- */
  document.querySelectorAll('[data-case-chart]').forEach(function (wrap) {
    var dataEl = wrap.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var months = data.months || [], roas = data.roas || [], spend = data.spend || [], purch = data.purch || [];
    var n = months.length;
    if (n < 2 || roas.length !== n || spend.length !== n) return;

    var period = wrap.getAttribute('data-period') || '';
    var hintIdle = wrap.getAttribute('data-hint-idle') || '';
    var hintHover = wrap.getAttribute('data-hint-hover') || '';
    var GREEN = '#8fd6b0', EASE = 'cubic-bezier(.2,.8,.2,1)';
    var W = 920, H = 400, padL = 56, padR = 22, padT = 30, padB = 56;
    var plotW = W - padL - padR, plotH = H - padT - padB, baseY = padT + plotH;
    var step = plotW / (n - 1);
    var yMax = Math.max(10, Math.ceil(Math.max.apply(null, roas)));
    var gridStep = Math.ceil(yMax / 5);
    var x = function (i) { return padL + i * step; };
    var yR = function (v) { return padT + (1 - v / yMax) * plotH; };
    var maxSpend = Math.max.apply(null, spend);
    var barMax = plotH * 0.6, barW = Math.min(38, step * 0.55);
    var NS = 'http://www.w3.org/2000/svg';
    var mk = function (tag, attrs) {
      var el = document.createElementNS(NS, tag);
      for (var k in attrs) el.setAttribute(k, attrs[k]);
      return el;
    };

    var svg = mk('svg', { viewBox: '0 0 ' + W + ' ' + H });
    for (var g = gridStep; g <= yMax; g += gridStep) {
      svg.appendChild(mk('line', { x1: padL, x2: W - padR, y1: yR(g), y2: yR(g), stroke: 'rgba(255,255,255,.08)', 'stroke-width': 1 }));
      var glabel = mk('text', { x: padL - 10, y: yR(g) + 3.5, 'text-anchor': 'end', 'font-family': "'JetBrains Mono',monospace", 'font-size': 11, fill: 'rgba(255,255,255,.4)' });
      glabel.textContent = g + '×';
      svg.appendChild(glabel);
    }

    var bars = spend.map(function (s, i) {
      var h = (s / maxSpend) * barMax;
      var bar = mk('rect', { x: x(i) - barW / 2, y: baseY, width: barW, height: 0, rx: 2, fill: 'rgba(255,255,255,.12)' });
      bar.dataset.h = h;
      if (!reduceMotion) bar.style.transition = 'height .8s ' + EASE + ' ' + (i * 45) + 'ms, y .8s ' + EASE + ' ' + (i * 45) + 'ms, fill .2s';
      svg.appendChild(bar);
      return bar;
    });

    var guide = mk('line', { x1: 0, x2: 0, y1: padT, y2: baseY, stroke: 'rgba(255,255,255,.28)', 'stroke-width': 1, 'stroke-dasharray': '3 4', visibility: 'hidden' });
    svg.appendChild(guide);

    var line = mk('polyline', {
      points: roas.map(function (v, i) { return x(i) + ',' + yR(v); }).join(' '),
      fill: 'none', stroke: GREEN, 'stroke-width': 2.5, 'stroke-linejoin': 'round', 'stroke-linecap': 'round',
      pathLength: 1, 'stroke-dasharray': 1, 'stroke-dashoffset': 1
    });
    if (!reduceMotion) line.style.transition = 'stroke-dashoffset 1.25s ' + EASE;
    svg.appendChild(line);

    var dots = roas.map(function (v, i) {
      var dot = mk('circle', { cx: x(i), cy: yR(v), r: 4, fill: GREEN, stroke: 'rgba(0,0,0,0)', 'stroke-width': 2, opacity: 0 });
      if (!reduceMotion) dot.style.transition = 'opacity .4s ease ' + ((i / (n - 1)) + 0.2) + 's, r .15s';
      svg.appendChild(dot);
      return dot;
    });

    var mlabels = months.map(function (m, i) {
      var t = mk('text', { x: x(i), y: H - 30, 'text-anchor': 'middle', 'font-family': "'JetBrains Mono',monospace", 'font-size': 11, fill: 'rgba(255,255,255,.5)' });
      t.textContent = m;
      svg.appendChild(t);
      return t;
    });

    var stage = document.createElement('div');
    stage.style.position = 'relative';
    stage.appendChild(svg);
    var tip = document.createElement('div');
    tip.className = 'case-chart__tip';
    stage.appendChild(tip);
    wrap.appendChild(stage);

    var hint = wrap.parentElement.querySelector('[data-chart-hint]');
    var setActive = function (idx) {
      bars.forEach(function (b, i) { b.setAttribute('fill', i === idx ? 'rgba(143,214,176,.30)' : 'rgba(255,255,255,.12)'); });
      dots.forEach(function (d, i) {
        d.setAttribute('r', i === idx ? 6 : 4);
        d.setAttribute('stroke', i === idx ? '#fff' : 'rgba(0,0,0,0)');
      });
      mlabels.forEach(function (t, i) { t.setAttribute('fill', i === idx ? '#fff' : 'rgba(255,255,255,.5)'); });
      if (idx == null) {
        guide.setAttribute('visibility', 'hidden');
        tip.classList.remove('is-visible');
        if (hint && hintIdle) hint.textContent = hintIdle;
        return;
      }
      guide.setAttribute('x1', x(idx)); guide.setAttribute('x2', x(idx));
      guide.setAttribute('visibility', 'visible');
      var leftPct = Math.min(85, Math.max(15, (x(idx) / W) * 100));
      tip.style.left = leftPct + '%';
      tip.innerHTML =
        '<p class="case-chart__tip-month">' + months[idx] + (period ? ' ' + period : '') + '</p>' +
        '<div class="case-chart__tip-rows">' +
        '<div class="case-chart__tip-row"><span>ROAS</span><span>' + roas[idx].toFixed(2) + '×</span></div>' +
        '<div class="case-chart__tip-row"><span>Spend</span><span>$' + spend[idx].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '</span></div>' +
        (purch[idx] != null ? '<div class="case-chart__tip-row"><span>Purchases</span><span>' + purch[idx].toLocaleString('en-US') + '</span></div>' : '') +
        '</div>';
      tip.classList.add('is-visible');
      if (hint && hintHover) hint.textContent = hintHover;
    };

    months.forEach(function (m, i) {
      var hit = mk('rect', { x: x(i) - step / 2, y: padT, width: step, height: plotH, fill: 'rgba(0,0,0,0)' });
      hit.style.cursor = 'pointer';
      hit.addEventListener('mouseenter', function () { setActive(i); });
      hit.addEventListener('touchstart', function () { setActive(i); }, { passive: true });
      svg.appendChild(hit);
    });
    svg.addEventListener('mouseleave', function () { setActive(null); });

    var draw = function () {
      bars.forEach(function (b) {
        var h = parseFloat(b.dataset.h);
        b.setAttribute('height', h);
        b.setAttribute('y', baseY - h);
      });
      line.setAttribute('stroke-dashoffset', 0);
      dots.forEach(function (d) { d.setAttribute('opacity', 1); });
    };
    var reset = function () {
      var els = bars.concat([line], dots);
      els.forEach(function (el) { var tr = el.style.transition; el.dataset.tr = tr; el.style.transition = 'none'; });
      bars.forEach(function (b) { b.setAttribute('height', 0); b.setAttribute('y', baseY); });
      line.setAttribute('stroke-dashoffset', 1);
      dots.forEach(function (d) { d.setAttribute('opacity', 0); });
      void svg.getBoundingClientRect();
      els.forEach(function (el) { el.style.transition = el.dataset.tr; });
      requestAnimationFrame(function () { requestAnimationFrame(draw); });
    };

    if (reduceMotion || !('IntersectionObserver' in window)) {
      draw();
    } else {
      var dio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { draw(); dio.disconnect(); }
        });
      }, { threshold: 0.25 });
      dio.observe(wrap);
      var replayBtn = wrap.parentElement.querySelector('[data-chart-replay]');
      if (replayBtn) {
        replayBtn.style.display = '';
        replayBtn.addEventListener('click', reset);
      }
    }
  });

  /* ----- Fade-in on scroll — once, rootMargin -80px, 0.9s ---------------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -80px 0px' }
    );
    document.querySelectorAll('.fade-in').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.fade-in').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
